import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { MachineGroupsResponse } from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const getMachineGroups = async (
  namespace: string,
): Promise<MachineGroupsResponse> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<MachineGroupsResponse>(
      `${url}/api/v1/ns/${namespace}/machine-groups`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch machine groups. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching machine groups.",
    );
  }
};
